import { render } from "./ScrollWatcher.vue?vue&type=template&id=6b7ac40e"
import script from "./ScrollWatcher.vue?vue&type=script&lang=js"
export * from "./ScrollWatcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__